import _ from "lodash";
import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import BaseContentDetailsPageView from "scripts/views/baseContentDetailsPageView";
import ContentDetailsVideoPageNavView from "scripts/views/contentDetailsVideoPageNavView";

import templateContentDetailsVideoPage from "templates/contentDetailsVideoPage.hbs";

const chan = Backbone.Radio.channel;

class ContentDetailsVideoPageView extends BaseContentDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
    bookshelfService = inject("bookshelfService"),
  ) {
    super(
      options,
      breadcrumbService,
      connectionService,
      securityService,
      bookshelfService,
    );
  }

  get template() {
    return templateContentDetailsVideoPage;
  }

  get events() {
    return _.extend({}, super.events, {
      "click #bb-video-details-player-button": "onPlayVideo",
    });
  }

  createNavView() {
    const organizationProperties = this.securityService.getUser().getActiveOrganizationProperty(
        "organizationProperties",
    );

    return new ContentDetailsVideoPageNavView({
      model: this.model,
      organizationProperties,
    });
  }

  onPlayVideo() {
    chan("display").request("playVideo", this.mediaModel);
    chan("tracking").trigger("viewer:click", this.mediaModel); // not listened to
    return false;
  }
}

export default ContentDetailsVideoPageView;
